/* ============================================================================
   tne-comprar.js — Revela o botão flutuante "Comprar na loja oficial"
   depois de N píxeis de scroll.

   Porquê: no topo da página o CTA primário é a candidatura a consultora
   ("Faça já seu cadastro!"). O botão de compra entra só depois de o
   visitante começar a explorar, para não competir com o hero.

   Falha em segurança: se este script não correr, o CSS deixa o botão
   visível (a regra de esconder está atrás de `.js`), portanto o link
   nunca fica inacessível.
   ============================================================================ */

(function () {
  'use strict';

  var fab = document.querySelector('[data-tne-comprar-fab]');
  if (!fab) return;

  var threshold = parseInt(fab.getAttribute('data-threshold'), 10);
  if (isNaN(threshold) || threshold < 0) threshold = 400;

  var ticking = false;

  function apply() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    fab.setAttribute('data-visible', y > threshold ? 'true' : 'false');
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // Estado inicial — cobre reloads a meio da página e âncoras (/#produtos).
  apply();
})();
